/**
 * External websites
 */
export const HIPHEN_CONTACT_US_PAGE = "https://www.hiphen-plant.com/contact/";
